import { PaymentTypes } from './payment.model';
import { IntegrationSources, PaymentMethodInput } from './paymentMethod.model';

export enum ResultActionContainers {
  DIRECT = 'direct',
  DISPLAY = 'display',
  IFRAME = 'iframe',
  PARAMETERS = 'parameters',
  REDIRECT = 'redirect',
  WINDOW = 'window',
}

export enum ResultActionTypes {
  HTML = 'html',
  REDIRECT = 'redirect',
  FORM = 'form',
  DISPLAY = 'display',
}

export enum ResultActionMethods {
  POST = 'POST',
  GET = 'GET',
}

export interface ResultAction {
  type: ResultActionTypes;
  url: string | null;
  method: ResultActionMethods;
  parameters: { [key: string]: string };
  container: ResultActionContainers;
  height: number;
  width: number;
  output: string | null;
  fields: PaymentMethodInput[];
}

export interface RegisterPaymentPayload {
  referenceId: string;
  type: PaymentTypes;
  walletId: string;
  sessionId: string;
  merchantId: string;
  registration: {
    accountId?: string | null;
    methodId: string;
    attributes: { [key: string]: string };
  };
}

export interface PaymentActionResult {
  transactionId: string;
  status: string;
  resultAction: ResultAction | null;
  description: string | null;
  //TODO: think about moving this parameter to separated 'resultAction'
  paymentAttributes: PaymentMethodInput[];
}

export interface AttributeErrorBag {
  [key: string]: string[];
}

export interface PaymentActionError {
  message: string;
  attributeErrorBag: AttributeErrorBag | null;
  errorDetails: { description: string } | null;
  transactionId: string | null;
  errCode?: string;
}

export interface ProcessPaymentPayload {
  paymentMethodId: string;
  vendor: string;
  merchantId: string;
  paymentType: PaymentTypes;
  userId: string;
  sessionId: string;
  paymentAttributes: { [key: string]: string };
  callbackParameterBag: { [key: string]: string };
  referenceId: string;
  source: IntegrationSources;
  accountId?: string | null;
}
